import log from "../../../utils/logger/library";

export const displaySurvey = (trigger) => {
    try {
        window.CBC.APP.AB.Testing.viewStateChange(trigger);
    } catch (error) {
        log.error(
            "(displaySurvey) UserSplitTest",
            new Error("Failed to change view state")
        );
    }
};
